import { ByPaymentMethodTotals as ByPaymentMethodTotalsDto } from '../types'

export enum Entity {
  Title = 'title',
  TitleGhost = 'titleGhost',
  Date = 'date',
  DateCount = 'dateCount',
  DateSum = 'dateSum',
  Total = 'total',
  TotalCount = 'totalCount',
  TotalSum = 'totalSum',
  IsOnlyTitle = 'isOnlyTitle',
  TitleTotal = 'titleTotal',
  RowInternal = 'rowInternal',
  RowBankCard = 'rowBankCard',
  RowSbp = 'rowSbp',
  RowCash = 'rowCash',
  RowGrandTotal = 'rowGrandTotal',
}

export type ByPaymentMethodTotals = ByPaymentMethodTotalsDto
